<template>
    <b-card >
        <!-- <b-card-header class="border-0">
            <h3 class="mb-0">Información de Naves</h3>
        </b-card-header> -->
        <div v-if="isLoading">
      Cargando datos, por favor espere...
    </div>
    <div v-else-if="errorLoading">
      Error al cargar los datos. Por favor, intente nuevamente.
    </div>
    <div v-else>
        <!-- <div class="user-role-display">
            UserRole cargado: {{ x }}
        </div> -->

                            <el-table
                      class="table-responsive table"
                      header-row-class-name="thead-light"
                      :data="paginatedItems"
                    >
                  <el-table-column
                        label="Nave"
                        min-width="200px"
                        >
                        <template v-slot="{ row }">
                            <b-media no-body class="align-items-center">
                            <b-media-body>
                                <span class="font-weight-500 name mb-0 text-sm">{{ NombreBuque(row) }}</span>
                            </b-media-body>
                            </b-media>
                        </template>
                        </el-table-column>

                        <el-table-column label="Consignatario" min-width="240px">
                      <template v-slot="{ row }">
                        <b-media no-body class="align-items-center">
                          <b-media-body>
                            <span class="font-weight-500 name mb-0 text-sm">{{ NombreConsignatario(row) }}</span>
                            <!-- Aquí se muestra la imagen -->
                          </b-media-body>
                        </b-media>
                      </template>
                    </el-table-column>

                        <el-table-column label="Producto" prop="budget" min-width="270px">
                            <template v-slot="{ row }">
                                <b-media no-body class="align-items-center">
                                    <b-media-body>
                                        <span class="font-weight-500 name mb-0 text-sm">
                                            <span v-for="(producto, asd) in Productiphite" :key="asd">
                                                <template v-if="producto.FACTOUS == row">
                                                    {{ producto.PRODUCTO }} <br>
                                                </template>
                                            </span>
                                        </span>
                                    </b-media-body>
                                </b-media>
                            </template>
                        </el-table-column>


                <el-table-column label="Cantidad"
                             min-width="130px"
                             prop="status">
                             <template v-slot="{ row }">
                                <b-media no-body class="align-items-center">
                                    <b-media-body>
                                        <span class="font-weight-600 name mb-0 text-sm">
                                            <span v-for="(producto, asd) in mappedItems" :key="asd">
                                                <template v-if="producto.FACTOUS == row">
                                                    - {{ producto.Cantidad }} TM <br>
                                                </template>
                                            </span>
                                        </span>
                                    </b-media-body>
                                </b-media>
                            </template>
            </el-table-column>



            <el-table-column label="Status" min-width="130px">
                <!-- <div class="avatar-group">
                    <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                       data-original-title="Ryan Tompson">
                        <img alt="Image placeholder" src="img/theme/team-1.jpg">
                    </a>
                    <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                       data-original-title="Romina Hadid">
                        <img alt="Image placeholder" src="img/theme/team-2.jpg">
                    </a>
                    <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                       data-original-title="Alexander Smith">
                        <img alt="Image placeholder" src="img/theme/team-3.jpg">
                    </a>
                    <a href="#" class="avatar avatar-sm rounded-circle" data-toggle="tooltip"
                       data-original-title="Jessica Doe">
                        <img alt="Image placeholder" src="img/theme/team-4.jpg">
                    </a>
                </div> -->
                    <template v-slot="{ row }">
                                <b-media no-body class="align-items-center">
                                    <b-media-body>
                                        <span class="font-weight-500 name mb-0 text-sm">
    <span style="text-align:center" v-if="Status(row) == 'NUEVO'">{{Status(row)}}</span>
    <span style="text-align:center; color:rgb(218, 122, 0)" v-else-if="Status(row) == 'CONFIRMADO'">{{Status(row)}}</span>
    <span style="text-align:center; color:rgb(3, 123, 228)" v-else-if="Status(row) == 'OPERACION'">OPERACIÓN</span>
    <span style="text-align:center; color:rgb(23, 162, 184)" v-else-if="Status(row) == 'DESPACHO'">{{Status(row)}}</span>
    <span style="text-align:center; color:red" v-else-if="Status(row) == 'ANULADO POR CLIENTE'">ANULADO</span>
    <span style="text-align:center; color:rgb(23, 162, 184)" v-else-if="Status(row) == 'REVISION'">{{Status(row)}}</span>
    <span style="text-align:center; color:rgb(0, 177, 31)" v-else-if="Status(row) == 'FINALIZADO'">{{Status(row)}}</span>  
                                        </span>
                                    </b-media-body>
                                </b-media>
                            </template>
            </el-table-column>

            <el-table-column label="Dashboard" prop="completion" min-width="240px">
                <template v-slot="{ row }">
                    <div class="d-flex align-items-center">
                        <!-- <span class="completion mr-2">{{ row.completion }}%</span> -->
                        <div>
                            <!-- Ajustar el enlace con los parámetros dinámicos -->
                            <router-link :to="'/dashboard/' + row">
                                Ver Dashboard <i class="fa fa-table"></i>
                            </router-link>
                        </div>
                    </div>
                </template>
            </el-table-column>

        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="15"
          layout="prev, pager, next"
          :total="totalItems">
        </el-pagination>

        </b-card-footer>
      </div>
    </b-card>

</template>
<script>
//   import projects from './../projects'
import axios from 'axios';
import { Table, TableColumn} from 'element-ui'
import { Pagination } from 'element-ui';

  export default {
    name: 'light-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      'el-pagination': Pagination
    },
    data() {
      return {
        // projects,
        currentPage: 1,
        perPage: 15,
        totalItems: 0, 
        listaDatos: [],
        listaNaves: [],
        listaDatosProducto:[],
        paginatedItems: [], 
        isLoading: true,
      errorLoading: false, // Nuevo est
      x: parseInt(localStorage.getItem('userRole')) || 0 // Asegúrate de convertirlo a número
        
      };
    },

    mounted() {
  this.loadData();
},

    computed:{

    counter() {
    return this.BuqueConsignatario.length
    },

    BuqueUnico() {
    let Bucardium = [...new Set(this.BuqueConsignatario.map(Buque => Buque.FACTOUS))];
    return Bucardium;
  },
  mappedItems() {
    let mapped = this.listaDatos.map((item) => {
      if (this.listaNaves) {
        this.listaNaves.forEach(productosnave => {
          if (productosnave.ID == item.ID_NAVES) {
            item.NAVE = productosnave.BUQUE_DE_DESCARGA;
            item.FECHA_ARRIBO = productosnave.FECHA_ARRIBO;
            item.FECHA_ATRAQUE = productosnave.FECHA_ATRAQUE;
            item["FIN DE OPERACIONES"] = productosnave["FIN DE OPERACIONES"];
            item.ESTATUS = productosnave.ESTATUS;
          }
        });
      }

      if (this.listaConsignave) {
        this.listaConsignave.forEach(productoxd => {
          if (productoxd.ID == item.ID_CONSIGNATARIO) {
            item.CONSIGNAVE = productoxd.CONSIGNATARIO;
          }
        });
      }

      if (this.listaClientesNave) {
        this.listaClientesNave.forEach(clientnave => {
          if (clientnave.ID == item.CONSIGNAVE) {
            item.CONSIGNAVE = clientnave.CONSIGNATARIO;
          }
        });
      }

      return {
        ID: item.ID,
        Buque: item.ID_NAVES,
        Consignatario: item.CONSIGNAVE,
        Producto: item.PRODUCTO,
        Cantidad: item.CANTIDAD,
        Bags: item.BAGS,
        Nave: item.NAVE,
        FACTOUS: item.ID_NAVES + '/' + item.ID_CONSIGNATARIO,
        ID_CONSIGNATARIO: item.ID_CONSIGNATARIO,
        Fecha_arribo: item.FECHA_ARRIBO,
        Fecha_atraque: item.FECHA_ATRAQUE,
        Fecha_Fin: item["FIN DE OPERACIONES"],
        Status: item.ESTATUS,
      };
    }).reverse();

    // Filtrar solo consignatarios que sean SAN FERNANDO S.A.
    return mapped
  },

 
            BuqueConsignatario() {
        const arr2 = this.mappedItems

        const unique2 = arr2.filter((obj, index) => {
          return index === arr2.findIndex(o => obj.FACTOUS === o.FACTOUS );
        });

        return unique2  
          },


         CantidadPorId() {
        var nuevoArray    = []
        var arrayTemporal = []
        for(var i=0; i<this.mappedItems.length; i++){
            arrayTemporal = nuevoArray.filter(resp => resp["Buque"] == this.mappedItems[i]["Buque"])
            if(arrayTemporal.length>0){
                nuevoArray[nuevoArray.indexOf(arrayTemporal[0])]["Cantidad"].push(this.mappedItems[i]["Cantidad"])
            }else{
                nuevoArray.push({"Buque" : this.mappedItems[i]["Buque"] , "Cantidad" : [this.mappedItems[i]["Cantidad"]]})
            }
        }
        return nuevoArray
      },

      Productiphite() {
      return this.listaDatos.map((item) => {
         this.listaDatosProducto.forEach(product => {
        if(product.ID == item.PRODUCTO)
         item.PRODUCTO = product.PRODUCTO
        
        
      this.listaConsignave.forEach(productoxd => {
          if(productoxd.ID  == item.ID_CONSIGNATARIO)
           item.CONSIGNAVE = productoxd.CONSIGNATARIO  
      });

   
      this.listaClientesNave.forEach(clientnave => {
          if(clientnave.ID  == item.CONSIGNAVE)
           item.CONSIGNAVE = clientnave.CONSIGNATARIO  
      });


      });

        return {
          BAGS: item.BAGS,
          BLS: item.BLS,
          PRODUCTO: item.PRODUCTO,
          FACTOUS: item.ID_NAVES+'/'+item.ID_CONSIGNATARIO,
          ID: item.ID,
          Consignatario: item.CONSIGNAVE,

        };
     })
    }, 

      },

      watch: {
        currentPage(newVal, oldVal) {
    console.log('currentPage changed from', oldVal, 'to', newVal);
    this.updatePaginatedItems();
  },
  BuqueUnico(newVal) {
    this.totalItems = newVal.length;
    this.updatePaginatedItems();
  }
},
      
      methods:{
        async loadData(retryCount = 3) {
      this.isLoading = true;
      this.errorLoading = false;
      let attempts = 0;

      while (attempts < retryCount) {
        attempts++;
    try {
      const responses = await Promise.all([
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=PRODUCTOS_NAVE"),
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=LISTA_PRODUCTOS"),
        axios.get("https://gsx2json.aygajustadores.com/api?id=1Tpui79bHcuKUYPu_n7hdNQSUdphCjtmHTKW1_BCHelw&RUBRO=GRANELES&columns=false&sheet=NAVES"),
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CONSIGNATARIO_NAVE"),
        axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CLIENTES_GRANEL")
      ]);

          this.listaDatos = responses[0].data.rows;
          this.listaDatosProducto = responses[1].data.rows;
          this.listaNaves = responses[2].data.rows;
          this.listaConsignave = responses[3].data.rows;
          this.listaClientesNave = responses[4].data.rows;

          this.totalItems = this.listaDatos.length; // Asumiendo que quieres el total de listaDatos
          this.updatePaginatedItems();

          this.isLoading = false;
          return;
        } catch (error) {
          console.error(`Error al cargar los datos (Intento ${attempts} de ${retryCount}):`, error);
          if (attempts >= retryCount) {
            this.isLoading = false;
            this.errorLoading = true;
          }
        }
  }
  },

        changePage(newPage) {
    this.$emit('input', newPage);
  },

  handleCurrentChange(newPage) {
    this.currentPage = newPage;
    this.updatePaginatedItems();
  },
  updatePaginatedItems() {
    const startIndex = (this.currentPage - 1) * this.perPage;
    const endIndex = startIndex + this.perPage;
    this.paginatedItems = this.BuqueUnico.slice(startIndex, endIndex);
  },

//   async loadData(retryCount = 3) {
//   while (retryCount > 0) {
//     try {
//       await Promise.all([
//         this.getLista(),
//         this.getListaNave(),
//         this.GetListaClienteNave(),
//         this.GetListaConsginave(),
//         this.getListaProducto()
//       ]);
//       console.log("Datos cargados con éxito");
//       this.isLoading = false;
//       break; // Salir del ciclo si todo se carga correctamente
//     } catch (error) {
//       console.error("Error al cargar los datos, reintentando...", error);
//       retryCount--;
//       if (retryCount === 0) {
//         console.error("Error al cargar los datos después de varios intentos");
//         this.isLoading = false;
//         // Considera mostrar un mensaje de error en la UI aquí
//       }
//       await new Promise(resolve => setTimeout(resolve, 1000)); // Espera 1 segundo
//     }
//   }
//   this.totalItems = this.BuqueUnico.length;
//   this.updatePaginatedItems();
// },



        

        NombreBuque(buques) {
                let nombrebuque = '';
                let res = this.BuqueConsignatario.filter(val => {
                    return val.FACTOUS === buques;
                });

                if (res) {
                    res.forEach((element, index) => {
                        nombrebuque += element.Nave;
                        if (index < res.length - 1) {
                            nombrebuque += ', ';
                        }
                    });
                }

                return nombrebuque;
            },

                  getImageUrl(consignatario) {
          if (consignatario === 'R. TRADING S.A.') {
            return '/img/brand/alicorp.png';
          }
          // Puedes añadir más condiciones para otros consignatarios si es necesario
          return '/img/brand/default-image.png'; // Una imagen por defecto
        },

        NombreConsignatario(buques) {
      let Consignatario = '';
      let res = this.BuqueConsignatario.filter(val => {
        return val.FACTOUS == buques;
      });

      // Lógica de roles
      if (this.x === 1) {
        // Muestra todos los consignatarios para el rol 1
        res.forEach(element => {
          Consignatario += element.Consignatario + '';
        });
      } else if (this.x === 2) {
        Consignatario = 'SAN FERNANDO S.A.';
      } else if (this.x === 3) {
        Consignatario = 'R. TRADING S.A.';
      } else if (this.x === 4) {
        // Muestra una lista de consignatarios específicos para el rol 4
        Consignatario = 'INKA AGRI RESOURCES S.A.C., EQUILIBRA PERU S.A., YARA PERU S.R.L.';
      } else {
        // Opcional: lógica para otros roles o un valor predeterminado
        Consignatario = 'Consignatario predeterminado';
      }

      return Consignatario.trimEnd(', '); // Elimina la última coma y espacio
    },

            Status(buques) {
         let stat = ''
        let res =  this.BuqueConsignatario.filter(val => {
            return val.FACTOUS == buques;
        })

        res.forEach(element => {
          stat += element.Status
        });

      return stat;

      },

    //   getLista(){
    //  axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=PRODUCTOS_NAVE" )
    // .then(response => {this.listaDatos = response.data.rows;
      
    // })
    // .catch(err=>{
    //   console.log(err);
    //     this.err = true;  
    // })
    // },

    // getListaProducto(){
    //  axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=LISTA_PRODUCTOS" )
    // .then(response => {this.listaDatosProducto = response.data.rows;
      
    // })
    // .catch(err=>{
    //   console.log(err);
    //     this.err = true;  
    // })
    // },

    // getListaNave(){
    //  axios.get("https://gsx2json.aygajustadores.com/api?id=1Tpui79bHcuKUYPu_n7hdNQSUdphCjtmHTKW1_BCHelw&RUBRO=GRANELES&columns=false&sheet=NAVES" )
    // .then(response => {this.listaNaves = response.data.rows;
      
    // })
    // .catch(err=>{
    //   console.log(err);
    //     this.err = true;  
    // })
    // },

    // GetListaConsginave(){
    //  axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CONSIGNATARIO_NAVE" )
    // .then(response => {this.listaConsignave = response.data.rows;
      
    // })
    // .catch(err=>{
    //   console.log(err);
    //     this.err = true;  
    // })
    // },

    // GetListaClienteNave(){
    //  axios.get("https://gsx2json.aygajustadores.com/api?id=1t5QZ5dFrbaKWbYBG-bRH6t474z4fDoDjTsu5HX6ceWo&columns=false&sheet=CLIENTES_GRANEL" )
    // .then(response => {this.listaClientesNave = response.data.rows;
      
    // })
    // .catch(err=>{
    //   console.log(err);
    //     this.err = true;  
    // })
    // },




    
        }
    }
      
</script>
<style>
.card .table td, .card .table th{
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}
</style>